import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { AttractImage, AttractScreenImageVO, LFImageLibraryGroupingVO, LFImageLibraryVO } from '../../services/attract-screen.model';
import { AttractScreenService } from '../../services/attract-screen.service';

@Component({
  selector: 'app-image-manager',
  templateUrl: './image-manager.component.html',
  styleUrls: ['./image-manager.component.scss']
})
export class ImageManagerComponent implements OnInit {
  private imageLibraries: LFImageLibraryVO[] | any;
  private selectedGroup: LFImageLibraryVO;
  private readonly filetypes = [ ".png", ".bmp", ".jpeg", ".jpg"];

  @Input() consoleType: string;
  @Output() imageAdded = new EventEmitter<AttractScreenImageVO>();
  @Output() imageSelected = new EventEmitter<AttractImage>();

  constructor(private attractScreenServ: AttractScreenService,
    private commonUtil: CommonUtil,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private amplitudeAnalytics: AmplitudeAnalyticsService) { }

  ngOnInit() {
    this.loader.startProcess();
    this.attractScreenServ.getImageLibrary(this.consoleType)
    .then(res => {
      this.processImageLibResponse(res);
    })
    .finally(() => {
      this.loader.endProcess();
    });
  }

  changeTab(type: LFImageLibraryVO) {
    this.selectedGroup = type;
  }

  addImages(files: FileList, formData: any, groupType: string) {
    if(files && this.validateFile(files[0])) {
      let filename = files[0].name.substr(0, files[0].name.lastIndexOf('.'));
      this.imageAdded.emit({
        name: filename,
        consoleType: this.consoleType,
        imageFile: files[0],
        formData: new FormData(formData),
        orignalFileName: filename,
        contentType: files[0].type,
        imageType: groupType,
        redRGB: 0,
        greenRGB: 0,   
        blueRGB: 0,
      });
    }
  }

  deleteImage(e: Event, imageId: string) {
    e.stopPropagation();
    this.loader.startProcess();
    this.attractScreenServ.deleteImage(imageId)
      .then(() => {
        let idx = this.selectedGroup.imagesList.findIndex(i => i.id === imageId);
        if(idx >= 0) {
          this.selectedGroup.imagesList.splice(idx, 1);
          this.selectedGroup.count = this.selectedGroup.imagesList.length;
        }
      })
      .catch(() => {
        console.error('API error.');
      })
      .finally(() => {
        this.loader.endProcess();
      });
  }

  addImageToScreen(image: AttractImage) {
    this.imageSelected.emit(image);
  }

  private validateFile(file: any) {    
    let maxSize = 10485760; // 10MB
    let fileExt = file.name.substr(file.name.lastIndexOf("."))?.toLowerCase();
    if(!this.filetypes.includes(fileExt)) {
      this.toast.creatToast(this.commonUtil.translateText('INVALID.FILE.FORMAT'), EToastType.ERROR);
      return false;
    } else if(file.size > maxSize) {
      this.toast.creatToast(this.commonUtil.translateText('FILE.SIZE.OVER.LIMIT'), EToastType.ERROR);
      return false;
    } else if(this.validateMaxImage(this.selectedGroup)) {
      this.toast.creatToast(this.commonUtil.translateText('USER.IMAGES.LIMIT.REACHED'), EToastType.ERROR);
    }
    return true;
  }

  private validateMaxImage(group: LFImageLibraryVO) {
    if(group && group.type =="U" && group.imagesList?.length >= 30) {
      return true;
    }
    return false;
  }

  private processImageLibResponse(imgLib: LFImageLibraryGroupingVO | any) {
    if(!imgLib && !imgLib.lfImageLibraries) return;
    imgLib.lfImageLibraries.forEach((g: any) => {
      if(g.type === 'U') g.name = this.commonUtil.translateText('MY.IMAGES');
      else if (g.type === 'S') g.name = this.commonUtil.translateText('SHARED.IMAGES');
      else if (g.type === 'LF') g.name = 'Life Fitness';
    });
    this.imageLibraries = imgLib.lfImageLibraries;
    this.selectedGroup = this.imageLibraries[0];
  }

  async onDrop(event: DndDropEvent, group: LFImageLibraryVO) {
    if(group && event.dropEffect === 'copy') {
      this.loader.startProcess();
      try {
        await this.attractScreenServ.copyImage(event.data.id, this.selectedGroup.type, group.type);
        if(!group.imagesList) group.imagesList = [];
        group.imagesList.unshift(event.data);
        group.count = group.imagesList.length;
      } catch (error) {
        console.error('API error.')
      }
      this.loader.endProcess();
    }
  }

}
